import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a2e836c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-xl font-bold text-h-primary-500" }
const _hoisted_2 = ["accept"]
const _hoisted_3 = {
  for: "file",
  class: "btn-primary p-2 rounded-md cursor-pointer"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-break mt-3 text-center" }
const _hoisted_7 = {
  id: "add-more-items",
  class: "flex items-center"
}
const _hoisted_8 = ["accept"]
const _hoisted_9 = {
  key: 0,
  for: "file",
  class: "cursor-pointer hover:scale-110 text-h-primary-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Errors = _resolveComponent("Errors")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(`border border-dashed ${
      _ctx.errors.length !== 0 ? 'border-red-500' : 'border-gray-400'
    } rounded-md w-100 overflow-auto scroll-style bg-white h-72`)
    }, [
      (_ctx.files.length === 0)
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            id: "empty-items",
            class: "flex justify-center items-center flex-col h-full gap-4",
            ref: "image-upload",
            onDrop: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.dropHandler($event, 'image-upload')), ["prevent"])),
            onDragover: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.dragOverHandler('image-upload')), ["prevent"])),
            onDragleave: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.dragLeaveHandler('image-upload')), ["prevent"]))
          }, [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Selecione os arquivos",
            en: "Select files",
          })), 1),
            _createVNode(_component_v_icon, {
              name: "md-uploadfile",
              scale: 3,
              class: "text-gray-500"
            }),
            _createElementVNode("input", {
              id: "file",
              type: "file",
              accept: _ctx.acceptFiles,
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addFiles && _ctx.addFiles(...args))),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetInput($event))),
              hidden: ""
            }, null, 40, _hoisted_2),
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.btnLabel), 1)
          ], 544))
        : (_openBlock(), _createElementBlock("section", {
            key: 1,
            id: "with-items",
            class: _normalizeClass(`flex flex-wrap items-center h-full ${
        _ctx.minFiles === 1 ? 'justify-center' : ''
      } gap-2 p-3`)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: _normalizeClass({ 'cursor-pointer': file?.id }),
                onClick: _withModifiers(($event: any) => (file?.id ? _ctx.handleEventClick(file) : ''), ["prevent","stop"])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(`bg-gray-100 rounded-md relative flex items-center justify-center border-2 border-h-primary-700
            ${_ctx.minFiles === 1 ? 'size-one' : 'size-default'}`)
                }, [
                  _createElementVNode("span", {
                    id: "remove-item",
                    class: "absolute -right-2 -top-2 bg-h-primary-500 rounded-full text-xs p-1 hover:scale-110",
                    onClick: _withModifiers(($event: any) => (_ctx.removeFiles(file?.id, i)), ["prevent","stop"])
                  }, [
                    _createVNode(_component_v_icon, {
                      name: "hi-solid-x-circle",
                      class: "text-white cursor-pointer"
                    })
                  ], 8, _hoisted_5),
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_v_icon, {
                      name: `md-${_ctx.fileType(file?.type || file?.extension)}`,
                      scale: 3,
                      class: "text-h-primary-500"
                    }, null, 8, ["name"]),
                    _createElementVNode("p", {
                      class: _normalizeClass(`p-2 font-bold text-xs text-h-primary-500 line-clamp-2 ${
                _ctx.minFiles === 1 ? 'span' : ''
              }`)
                    }, _toDisplayString(file?.name), 3)
                  ])
                ], 2)
              ], 10, _hoisted_4))
            }), 128)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("input", {
                id: "file",
                type: "file",
                accept: _ctx.acceptFiles,
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addFiles && _ctx.addFiles(...args))),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetInput($event))),
                hidden: ""
              }, null, 40, _hoisted_8),
              (_ctx.files?.length < _ctx.minFiles)
                ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                    _createVNode(_component_v_icon, {
                      name: "hi-solid-plus-circle",
                      scale: 2
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2))
    ], 2),
    _createVNode(_component_Errors, { errors: _ctx.errors }, null, 8, ["errors"])
  ], 64))
}